// Illustration « écusson brodé » générée en SVG : motif selon le type de zone ou l'icône du secteur.
const MOTIF = {
  littoral: <><path d="M20 118 Q60 100 100 118 T180 118" /><path d="M20 134 Q60 116 100 134 T180 134" /><circle cx="140" cy="62" r="18" /><path d="M60 118 L84 70 L84 118 Z" /></>,
  colline: <><path d="M10 130 Q60 70 110 120 T200 110" /><path d="M40 118 L70 84 L100 118 Z" /><path d="M70 84 L70 60" /><rect x="64" y="62" width="12" height="10" /></>,
  montagne: <><path d="M10 140 L60 60 L90 100 L120 50 L170 140" /><path d="M48 80 L60 60 L72 80" /><path d="M110 70 L120 50 L132 70" /><circle cx="160" cy="54" r="12" /></>,
  ville: <><rect x="30" y="80" width="30" height="60" /><rect x="70" y="56" width="36" height="84" /><rect x="116" y="90" width="26" height="50" /><rect x="150" y="70" width="30" height="70" /><path d="M10 140 H190" /></>,
  tech: <><rect x="40" y="60" width="120" height="70" rx="6" /><path d="M60 80 H140 M60 96 H120 M60 112 H100" /><circle cx="150" cy="58" r="6" /></>,
};

export function ZoneArt({ type = "ville", label, className = "", icon: Icon = null }) {
  return (
    <div className={`relative overflow-hidden k-weave text-[#1C1917] ${className}`} role="img" aria-label={label} data-testid="zone-art">
      <div className="absolute inset-3 sm:inset-4 k-stitch" />
      <svg viewBox="0 0 200 160" className="absolute inset-0 w-full h-full p-8 sm:p-10" fill="none" stroke="#C25E38" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="4 3" aria-hidden>
        {Icon ? null : MOTIF[type]}
      </svg>
      {Icon && <div className="absolute inset-0 flex items-center justify-center text-[#C25E38]"><Icon size={88} strokeWidth={1.1} /></div>}
      <div className="absolute left-6 bottom-6 sm:left-8 sm:bottom-8 max-w-[80%]">
        <span className="font-mono-k text-[10px] tracking-[0.2em] uppercase opacity-70">Atelier KOUOH</span>
        <p className="font-display italic text-xl mt-1">{label}</p>
      </div>
    </div>
  );
}

export function ZonePhoto({ photo, alt, className = "", ...art }) {
  if (!photo) return <ZoneArt className={className} label={alt} {...art} />;
  return (
    <figure className={`relative overflow-hidden ${className}`}>
      <img src={photo.url} alt={alt} loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
      {photo.author && <figcaption className="absolute bottom-0 right-0 bg-[#1C1917]/70 text-[#FBF9F5] text-[10px] px-2 py-1 max-w-full truncate"><a href={photo.page} target="_blank" rel="noopener noreferrer" dangerouslySetInnerHTML={{ __html: `Photo : ${photo.author} · ${photo.license}` }} /></figcaption>}
    </figure>
  );
}
